class cardProduct extends HTMLElement {
  constructor() {
    super();
    let self = this;

    if (this.querySelector('.btn-quick-add-cart')) {
      this.querySelector('.btn-quick-add-cart').addEventListener('click', async function () {
        await self.openPopUpQuickAddCart();
      });
    }

    if (this.querySelector('.quantity-color')) {
      this.querySelector('.quantity-color').addEventListener('click', async function () {
        await self.openPopUpQuickAddCart();
      });
    }

    this.renderSliderCardPdp();

    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  renderSliderCardPdp() {
    if (!this.classList.contains('renderSlider')) {
      let idProduct = this.getAttribute('data-id');
      let idSection = this.getAttribute('data-id-section');
      let nameSliderThumbnail = '.slider-thumbnail-' + idProduct + '-' + idSection;
      let nameSlider = '.slider-' + idProduct + '-' + idSection;
      let nameNext = '.swiper-button-next-' + idProduct + '-' + idSection;
      let namePrev = '.swiper-button-prev-' + idProduct + '-' + idSection;
      let nameScrollBar = '.swiper-scrollbar-' + idProduct + '-' + idSection;
      this.initSwiper(nameSliderThumbnail, nameSlider, nameNext, namePrev, nameScrollBar);
      this.classList.add('renderSlider');
    }
  }

  resetPopupMobile(colorSelect) {
    if (!colorSelect && window.screen.width <= 768) {
      document.getElementById('model-quick-add-mobile').classList.remove('active');
      document.querySelector('.product-card-drawer').style.visibility = 'visible';
      document.getElementById('model-quick-add-mobile').querySelector('.variant-color').classList.add('active');
      document.getElementById('model-quick-add-mobile').querySelector('.variant-option').classList.remove('active');
    }
  }

  async getDataVariationProduct(url) {
    let res = await fetch(url);
    return new DOMParser().parseFromString(await res.text(), 'text/html');
  }

  async addProductToCartWhenOnlyOption(selectOption) {
    let self = this;
    self.clearError();
    if (this.querySelector('.add-to-cart-button-class')) {
      this.querySelector('.add-to-cart-button-class').classList.remove('error');
    }
    let idVariant = selectOption.querySelector('option').value;
    this.querySelector('.btn-quick-add-cart').querySelector('.loading__spinner').classList.remove('hidden');
    this.querySelector('.btn-quick-add-cart').querySelector('.icon-add-cart').classList.add('hidden');
    await self.addToCart(idVariant, self);
    this.querySelector('.btn-quick-add-cart').querySelector('.loading__spinner').classList.add('hidden');
    this.querySelector('.btn-quick-add-cart').querySelector('.icon-add-cart').classList.remove('hidden');
  }

  openOrCloseLoadingCart(status) {
    if (status == 'open') {
      this.querySelector('.btn-quick-add-cart').querySelector('.loading__spinner').classList.remove('hidden');
      this.querySelector('.btn-quick-add-cart').querySelector('.icon-add-cart').classList.add('hidden');
    } else {
      this.querySelector('.btn-quick-add-cart').querySelector('.loading__spinner').classList.add('hidden');
      this.querySelector('.btn-quick-add-cart').querySelector('.icon-add-cart').classList.remove('hidden');
    }
  }

  async openPopUpQuickAddCart(colorSelect = false) {
    let self = this;

    // --- Fallback: marca un input si no hay ninguno checked
    const activeThumbInput = self.querySelector('.swiper-slide-thumb-active input');
    if (activeThumbInput) {
      activeThumbInput.checked = true;
    } else {
      const firstAnyInput =
        self.querySelector('input[type="radio"]') ||
        self.querySelector('input[type="checkbox"]') ||
        self.querySelector('input');
      if (firstAnyInput) firstAnyInput.checked = true;
    }

    let parent = this.closest('.item-product-add-cart') || this.closest('.swiper-slide');
    let typeProduct = this.getAttribute('data-type-product');

    document.querySelectorAll('.notification.error').forEach((item) => item.remove());
    document.querySelectorAll('.add-to-cart-button-class').forEach((item) => item.classList.remove('error'));

    const facets = document.querySelector('.facets-container');
    if (facets) facets.classList.add('hidden');

    self.openOrCloseLoadingCart('open');
    this.resetPopupMobile(colorSelect);
    await self.renderContentPopup(typeProduct, parent, self);

    // helpers para checked con fallback al primero
    const mobileRoot = document.getElementById('model-quick-add-mobile');
    const getDesktopOpt = () =>
      this.querySelector('.option-varian-1:checked') || this.querySelector('.option-varian-1');
    const getMobileOpt = () =>
      mobileRoot
        ? mobileRoot.querySelector('.option-varian-1:checked') || mobileRoot.querySelector('.option-varian-1')
        : null;

    if (
      typeProduct == 'simple' ||
      this.querySelector('.option-varian-1') ||
      (mobileRoot && mobileRoot.querySelector('.option-varian-1'))
    ) {
      const hasUsableDesktop = window.screen.width > 768 && !!getDesktopOpt();
      const hasUsableMobile = !!getMobileOpt();

      if ((typeProduct == 'simple' && window.screen.width > 768) || hasUsableDesktop || hasUsableMobile) {
        let productIdSelect = null,
          urlProduct = null;

        const desktopOpt = getDesktopOpt();
        if (desktopOpt) {
          productIdSelect = desktopOpt.getAttribute('data-product-id');
          urlProduct = desktopOpt.getAttribute('data-product-url');
        }

        const mobileOpt = getMobileOpt();
        if (mobileOpt) {
          productIdSelect = mobileOpt.getAttribute('data-product-id');
          urlProduct = mobileOpt.getAttribute('data-product-url');
        }

        let elProduct = this,
          selectOption = null;
        if (typeProduct == 'bundle') {
          elProduct = document.querySelector(`slider-image-card[data-id="${productIdSelect}"]`);
        }

        if (elProduct) {
          selectOption = elProduct.querySelector('.main_product_form_varaiants_class');
        } else {
          const doc = await self.getDataVariationProduct(urlProduct);
          const pdp = doc && doc.getElementById('content-pdp');
          if (pdp) selectOption = pdp.querySelector('#products-select-variants');
        }

        if (selectOption && selectOption.querySelectorAll('option').length <= 1) {
          await self.addProductToCartWhenOnlyOption(selectOption);
          const btn = this.querySelector('.btn-quick-add-cart');
          if (btn) btn.setAttribute('data-open', 'true');
          self.openOrCloseLoadingCart('close');
          return;
        }
      } else {
        if (window.screen.width <= 768) {
          self.openOrCloseLoadingCart('close');
          await this.renderPopupMobile(self, typeProduct);
          return;
        } else {
          self.openOrCloseLoadingCart('close');
          this.showError(window.productString.errorChoose);
          const elAddToCart = this.querySelector('.add-to-cart-button-class');
          if (elAddToCart) {
            elAddToCart.classList.add('error');
            setTimeout(() => elAddToCart.classList.remove('error'), 2000);
          }
          return;
        }
      }
    } else {
      let selectOption = self.querySelector('.main_product_form_varaiants_class');
      if (selectOption && selectOption.querySelectorAll('option').length <= 1) {
        self.openOrCloseLoadingCart('close');
        await self.addProductToCartWhenOnlyOption(selectOption);
        return;
      }
    }

    self.openOrCloseLoadingCart('close');
  }

  async renderContentPopup(typeProduct, parent, self) {
    let statusOpen = this.querySelector('.btn-quick-add-cart').getAttribute('data-open');
    if (statusOpen == 'false') {
      this.querySelector('.popup-quick-add').classList.remove('active');
      this.querySelector('.btn-quick-add-cart').setAttribute('data-open', 'true');
      if (this.querySelector('.add-to-cart-button-class')) {
        this.querySelector('.add-to-cart-button-class').classList.remove('notshow');
      }
      return;
    }

    if (parent.querySelector('.card-slider-media').querySelector('.popup-quick-add')) {
      parent.querySelector('.card-slider-media').querySelector('.popup-quick-add').remove();
    }
    if (document.getElementById('model-quick-add-mobile').querySelector('.variant-option')) {
      document.getElementById('model-quick-add-mobile').querySelector('.variant-option').innerHTML = '';
    }
    if (
      typeProduct == 'simple' ||
      this.querySelector('.option-varian-1:checked') ||
      document.getElementById('model-quick-add-mobile').querySelector('.option-varian-1:checked')
    ) {
      if (this.querySelector('.card_product_class').querySelector('.notification.error')) {
        this.querySelector('.card_product_class').querySelector('.notification.error').remove();
      }
      if (this.querySelector('.add-to-cart-button-class')) {
        this.querySelector('.add-to-cart-button-class').classList.remove('error');
      }

      if (!this.querySelector('.popup-quick-add')) {
        let selectOption = null;
        let elPopupChoose = document.createElement('div');
        elPopupChoose.className = 'popup-quick-add';
        let productIdSelect = null,
          urlProduct = null;
        if (this.querySelector('.option-varian-1:checked')) {
          productIdSelect = this.querySelector('.option-varian-1:checked').getAttribute('data-product-id');
          urlProduct = this.querySelector('.option-varian-1:checked').getAttribute('data-product-url');
        }
        if (document.getElementById('model-quick-add-mobile').querySelector('.option-varian-1:checked')) {
          productIdSelect = document
            .getElementById('model-quick-add-mobile')
            .querySelector('.option-varian-1:checked')
            .getAttribute('data-product-id');
          urlProduct = document
            .getElementById('model-quick-add-mobile')
            .querySelector('.option-varian-1:checked')
            .getAttribute('data-product-url');
        }
        let elProduct = this;
        if (typeProduct == 'bundle') {
          elProduct = document.querySelector(`slider-image-card[data-id="${productIdSelect}"]`);
        }
        let jsonData = null;
        if (elProduct) {
          jsonData = elProduct.querySelector('script[type="application/json"]');
          selectOption = elProduct.querySelector('.main_product_form_varaiants_class');
        } else {
          let doc = await self.getDataVariationProduct(urlProduct);
          selectOption = doc.getElementById('content-pdp').querySelector('#products-select-variants');
          jsonData = doc.getElementById('content-pdp').querySelector('script[type="application/json"]');
        }
        if (selectOption.querySelectorAll('option').length > 1) {
          elPopupChoose.classList.add('active');
        }
        jsonData = jsonData.innerHTML;
        let dataVariation = JSON.parse(jsonData);

        let hasItemVariant = false;
        if (jsonData) {
          let content = "<div class='title'><h2>Ajustar</h2></div>";
          let onlySize = true;
          let index = 2;
          dataVariation.forEach((item) => {
            if (item.name != 'Color') {
              let classOnly = item.values.length <= 1 ? 'option-varian-select-only' : '';

              let classColumn = '';
              if (item.name == 'Calibre' && item.values.length >= 3) {
                if (
                  (dataVariation.some((option) => option.name == 'Color') && dataVariation.length > 2) ||
                  (!dataVariation.some((option) => option.name == 'Color') && dataVariation.length > 1)
                ) {
                  classColumn = 'option-grid-3-cols';
                }
              }
              content += `<div class="option-varian-${item.name} option-varian-select ${classOnly} ${classColumn}">`;
              item.values.forEach((option) => {
                content += `<input class="option-varian-${index}" type="radio" id="option-${item.name}-${option}" value="${option}" name="option-${item.name}"><label class="option-varian" for="option-${item.name}-${option}">${option}</label>`;
              });
              content += `</div>`;
              if (item.name != 'Calibre') {
                onlySize = false;
              }
              hasItemVariant = true;
              index++;
            }
          });

          if (hasItemVariant) {
            content +=
              '<div class="btn-submit-quick-add-cart">Añadir al carrito <div class="loading__spinner hidden">' +
              '  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="61px" height="61px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">\n' +
              '    <circle cx="50" cy="50" fill="none" stroke="#000" stroke-width="11" r="35" stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(220.188 50 50)">\n' +
              '      <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>\n' +
              '    </circle>\n' +
              '  </svg></div></div>';
          }
          if (onlySize) {
            elPopupChoose.classList.add('only-variant-size');
          }
          elPopupChoose.innerHTML = content;
          if (window.screen.width > 768) {
            parent.querySelector('.card-slider-media').appendChild(elPopupChoose);
            if (this.querySelector('.btn-submit-quick-add-cart')) {
              this.querySelector('.btn-submit-quick-add-cart').addEventListener('click', async function () {
                await self.quickAddCart();
              });
            }
            this.querySelector('.btn-quick-add-cart').setAttribute('data-open', 'false');
            if (this.querySelector('.add-to-cart-button-class')) {
              this.querySelector('.add-to-cart-button-class').classList.add('notshow');
            }
          } else {
            document.getElementById('model-quick-add-mobile').querySelector('.variant-option').innerHTML =
              elPopupChoose.innerHTML;
            if (typeProduct == 'bundle') {
              let elBack = document.createElement('div');
              elBack.className = 'btn-back';
              elBack.innerHTML = 'Seleccionar otra';
              elBack.addEventListener('click', function () {
                document.getElementById('model-quick-add-mobile').querySelector('.title').innerHTML =
                  'Seleccionar producto';
                document
                  .getElementById('model-quick-add-mobile')
                  .querySelector('.variant-color')
                  .classList.add('active');
                document
                  .getElementById('model-quick-add-mobile')
                  .querySelector('.variant-option')
                  .classList.remove('active');
              });
              document.getElementById('model-quick-add-mobile').querySelector('.variant-option').appendChild(elBack);
            } else {
              document
                .getElementById('model-quick-add-mobile')
                .querySelector('.btn-submit-quick-add-cart')
                .classList.add('btn-full-width');
            }

            if (document.getElementById('model-quick-add-mobile').querySelector('.btn-submit-quick-add-cart')) {
              document
                .getElementById('model-quick-add-mobile')
                .querySelector('.btn-submit-quick-add-cart')
                .addEventListener('click', async function () {
                  await self.quickAddCart();
                });
            }
            document
              .getElementById('model-quick-add-mobile')
              .querySelector('.variant-color')
              .classList.remove('active');
            document.getElementById('model-quick-add-mobile').querySelector('.variant-option').classList.add('active');
          }
        }
      } else {
        let statusOpen = this.querySelector('.btn-quick-add-cart').getAttribute('data-open');
        if (statusOpen == 'true') {
          this.querySelector('.popup-quick-add').classList.add('active');
          this.querySelector('.btn-quick-add-cart').setAttribute('data-open', 'false');
          if (this.querySelector('.add-to-cart-button-class')) {
            this.querySelector('.add-to-cart-button-class').classList.add('notshow');
          }
        }
      }
    }
  }

  initSwiper(nameSliderThumbnail, nameSlider, nameNext, namePrev, nameScrollBar) {
    window.setTimeout(() => {
      var sliderThumbnail = new Swiper(`${nameSliderThumbnail}`, {
        slidesPerView: 'auto',
        loop: true,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        scrollbar: {
          el: `${nameScrollBar}`,
          hide: false,
        },
      });
      var slider = new Swiper(`${nameSlider}`, {
        loop: true,
        navigation: {
          nextEl: `${nameNext}`,
          prevEl: `${namePrev}`,
        },
        thumbs: {
          swiper: sliderThumbnail,
        },
        on: {
          slideChange: function () {
            // Usar realIndex para obtener el índice real sin duplicados del loop
            const realIndex = slider.realIndex;
            sliderThumbnail.slideTo(realIndex);

            // Pausar todos los videos primero
            const allVideos = slider.el.querySelectorAll('video');
            allVideos.forEach((video) => {
              video.pause();
              video.currentTime = 0;
            });

            // Obtener la slide activa usando realIndex
            const activeSlide = slider.slides[realIndex];

            if (activeSlide && activeSlide.hasAttribute('data-is-video')) {
              // Reproducir el video de la slide activa
              const activeVideo = activeSlide.querySelector('video');
              if (activeVideo) {
                setTimeout(() => {
                  activeVideo.play().catch((e) => {
                    console.log('Error playing video:', e);
                    // Si falla la reproducción, intentar cargar el video
                    activeVideo.load();
                  });
                }, 100);
              }

              // Actualizar el thumbnail seleccionado
              const videoThumbnail = thumbnailContainer.querySelector('.change-id-variant-color[data-is-video="true"]');
              if (videoThumbnail) {
                const videoInput = videoThumbnail.querySelector('input[data-is-video="true"]');
                if (videoInput) {
                  // Desmarcar todos los thumbnails
                  thumbnailContainer.querySelectorAll('input[type="radio"]').forEach((input) => {
                    input.checked = false;
                  });
                  // Marcar el thumbnail del video
                  videoInput.checked = true;
                }
              }
            } else {
              // Actualizar el thumbnail correspondiente a la slide activa
              if (activeSlide && activeSlide.hasAttribute('data-variant-id')) {
                const variantId = activeSlide.getAttribute('data-variant-id');
                const correspondingThumbnail = thumbnailContainer.querySelector(`input[value="${variantId}"]`);
                if (correspondingThumbnail) {
                  // Desmarcar todos los thumbnails
                  thumbnailContainer.querySelectorAll('input[type="radio"]').forEach((input) => {
                    input.checked = false;
                  });
                  // Marcar el thumbnail correspondiente
                  correspondingThumbnail.checked = true;
                }
              }
            }
          },
          touchStart: function () {
            // Pausar videos cuando se inicia el touch
            const allVideos = slider.el.querySelectorAll('video');
            allVideos.forEach((video) => {
              video.pause();
            });
          },
        },
      });

      // Deshabilitar eventos de touch en videos para evitar interferencia con el swiper
      const allVideos = document.querySelectorAll(`${nameSlider} video`);
      allVideos.forEach((video) => {
        video.style.pointerEvents = 'none';
        video.style.touchAction = 'none';
        video.addEventListener('touchstart', (e) => e.preventDefault(), { passive: false });
        video.addEventListener('touchmove', (e) => e.preventDefault(), { passive: false });
        video.addEventListener('touchend', (e) => e.preventDefault(), { passive: false });
        video.addEventListener('dragstart', (e) => e.preventDefault());
        video.addEventListener('contextmenu', (e) => e.preventDefault());
      });

      // Manejar clicks en thumbnails con video
      const thumbnailContainer = document.querySelector(nameSliderThumbnail);
      if (thumbnailContainer) {
        const videoThumbnail = thumbnailContainer.querySelector('.change-id-variant-color[data-is-video="true"]');
        if (videoThumbnail) {
          const videoInput = videoThumbnail.querySelector('input[data-is-video="true"]');
          if (videoInput) {
            videoInput.addEventListener('change', function () {
              // Encontrar la slide del video en el slider principal
              const mainSlider = document.querySelector(nameSlider);
              if (mainSlider) {
                const videoSlide = mainSlider.querySelector('.swiper-slide[data-is-video="true"]');
                if (videoSlide) {
                  // Obtener el índice real de la slide del video (sin duplicados del loop)
                  const slides = Array.from(mainSlider.querySelectorAll('.swiper-slide'));
                  const videoSlideIndex = slides.indexOf(videoSlide);
                  if (videoSlideIndex !== -1) {
                    // Pausar todos los videos antes de cambiar
                    const allVideos = mainSlider.querySelectorAll('video');
                    allVideos.forEach((video) => {
                      video.pause();
                    });

                    // Usar slideToLoop para manejar correctamente el loop
                    slider.slideToLoop(videoSlideIndex);

                    // Reproducir el video después de un pequeño delay
                    setTimeout(() => {
                      const activeVideo = videoSlide.querySelector('video');
                      if (activeVideo) {
                        activeVideo.currentTime = 0;
                        activeVideo.play().catch((e) => console.log('Error playing video:', e));
                      }
                    }, 150);
                  }
                }
              }
            });
          }
        }
      }

      // Manejar clicks en thumbnails de productos relacionados para cambiar el slider
      const allThumbnails = document.querySelectorAll(`${nameSliderThumbnail} .change-id-variant-color input`);
      allThumbnails.forEach((input) => {
        input.addEventListener('change', function () {
          const variantId = this.value;
          const mainSlider = document.querySelector(nameSlider);

          if (mainSlider) {
            // Si es el video, ya lo manejamos arriba
            if (this.hasAttribute('data-is-video')) {
              return;
            }

            // Pausar todos los videos antes de cambiar
            const allVideos = mainSlider.querySelectorAll('video');
            allVideos.forEach((video) => {
              video.pause();
            });

            // Buscar la slide correspondiente a esta variante
            const targetSlide = mainSlider.querySelector(`.swiper-slide[data-variant-id="${variantId}"]`);
            if (targetSlide) {
              const slides = Array.from(mainSlider.querySelectorAll('.swiper-slide'));
              const targetIndex = slides.indexOf(targetSlide);
              if (targetIndex !== -1) {
                // Usar slideToLoop para manejar correctamente el loop
                slider.slideToLoop(targetIndex);
              }
            }
          }
        });
      });

      // Filter Collection slide by color
      const targetColor = document.body.dataset.collectionColor;

      if (targetColor) {
        const slides = document.querySelectorAll(`${nameSliderThumbnail} .swiper-slide`);
        const targetIndex = Array.from(slides).findIndex((slide) => {
          return slide.dataset.color?.toLowerCase() === targetColor.toLowerCase();
        });

        if (targetIndex !== -1) {
          setTimeout(() => {
            sliderThumbnail.slideToLoop?.(targetIndex, 0);
            slider.slideToLoop?.(targetIndex, 0);
            slides[targetIndex].classList.add('swiper-slide-active-color');
          }, 100);
        }
      }
    }, 300);
  }

  async renderPopupMobile(self, typeProduct) {
    let modelMobile = document.getElementById('model-quick-add-mobile');
    modelMobile.querySelector('.title').innerHTML = 'Seleccionar producto';

    if (typeProduct == 'simple') {
      let urlProduct = this.querySelector('.pdp-normal').querySelector('a').getAttribute('href');
      let doc = await self.getDataVariationProduct(urlProduct);
      let img = this.querySelector('.pdp-normal').querySelector('img');
      self.openTabMobileOnly(img.getAttribute('src'), doc, typeProduct);
    } else {
      if (self.querySelector('.add-to-cart-button-class')) {
        modelMobile.querySelector('.variant-color').innerHTML =
          self.querySelector('.add-to-cart-button-class').innerHTML;
      }
    }

    modelMobile.classList.add('active');
    document.querySelector('.product-card-drawer').style.visibility = 'visible';
    modelMobile.querySelector('.variant-color').classList.remove('active');
    modelMobile.querySelector('.variant-option').classList.remove('active');

    if (typeProduct == 'bundle') {
      modelMobile.querySelector('.variant-color').classList.add('active');
    } else {
      modelMobile.querySelector('.variant-option').classList.add('active');
    }

    modelMobile.querySelector('.btn-close-popup').addEventListener('click', function () {
      self.closePopupMobile();
    });
    document.querySelector('.product-card-drawer').addEventListener('click', function () {
      self.closePopupMobile();
    });
    if (typeProduct == 'bundle') {
      modelMobile.querySelector('.variant-color').querySelector('.slider-thumbnail').className =
        'swiper-container slider-thumbnail-mobile';
      modelMobile
        .querySelector('.variant-color')
        .querySelectorAll('input[type="radio"]')
        .forEach((input) => {
          input.name = 'mobile-' + input.name;
          let id = input.id;
          let idNew = 'mobile-' + id;
          input.setAttribute('id', idNew);
          modelMobile.querySelector(`label[for="${id}"]`).setAttribute('for', idNew);
          input.addEventListener('click', async function () {
            let modelMobile = document.getElementById('model-quick-add-mobile');
            document.getElementById('loading__spinner_main_model').classList.remove('hidden');
            modelMobile.querySelector('.title').style.opacity = '0.5';
            modelMobile.querySelector('.active').style.opacity = '0.5';
            try {
              let productIdSelect = modelMobile
                .querySelector('.option-varian-1:checked')
                .getAttribute('data-product-id');
              let elProduct = this;
              if (typeProduct == 'bundle') {
                elProduct = document.querySelector(`slider-image-card[data-id="${productIdSelect}"]`);
              }

              let urlProduct = modelMobile.querySelector('.option-varian-1:checked').getAttribute('data-product-url');
              let selectOption = null;

              let doc = await self.getDataVariationProduct(urlProduct);

              if (elProduct) {
                selectOption = elProduct.querySelector('.main_product_form_varaiants_class');
              } else {
                selectOption = doc.getElementById('content-pdp').querySelector('#products-select-variants');
              }
              if (selectOption.querySelectorAll('option').length > 1) {
                await self.openPopUpQuickAddCart(true);
              } else {
                let parent = input.closest('div'),
                  img = parent.querySelector('img');
                self.openTabMobileOnly(img.getAttribute('src'), doc);
              }
            } finally {
              document.getElementById('loading__spinner_main_model').classList.add('hidden');
              modelMobile.querySelector('.title').style.opacity = '1';
              modelMobile.querySelector('.active').style.opacity = '1';
            }
          });
        });
    }

    let idProduct = self.getAttribute('data-id');
    let idSection = this.getAttribute('data-id-section');
    let nameSliderThumbnail = '.slider-thumbnail-mobile';
    let nameSlider = '.slider-' + idProduct + '-' + idSection;
    let nameNext = '.swiper-button-next-' + idProduct + '-' + idSection;
    let namePrev = '.swiper-button-prev-' + idProduct + '-' + idSection;

    self.initSwiper(nameSliderThumbnail, nameSlider, nameNext, namePrev);
  }

  closePopupMobile() {
    let modelMobile = document.getElementById('model-quick-add-mobile');
    modelMobile.classList.remove('active');
    document.querySelector('.product-card-drawer').style.visibility = 'hidden';
    modelMobile.querySelector('.variant-color').innerHTML = '';
    modelMobile.querySelector('.variant-option').innerHTML = '';
    if (document.querySelector('.facets-container')) {
      document.querySelector('.facets-container').classList.remove('hidden');
    }
  }

  openTabMobileOnly(imgSrc, doc, typeProduct = null) {
    let self = this;
    let modelMobile = document.getElementById('model-quick-add-mobile');
    modelMobile.querySelector('.variant-color').classList.remove('active');
    modelMobile.querySelector('.variant-option').classList.add('active');
    modelMobile.querySelector('.title').innerHTML = 'Añadido al carrito';
    modelMobile.querySelector('.variant-option').innerHTML = '';

    let content = document.createElement('div');

    let gridEl = document.createElement('div');
    gridEl.className = 'flex';

    let imgEl = document.createElement('img');
    if (imgSrc.search('/?/') > -1) {
      imgSrc = imgSrc.split('?');
      imgSrc = imgSrc[0];
    }
    imgEl.src = imgSrc;

    let divElImg = document.createElement('div');
    divElImg.className = 'img-popup';
    divElImg.appendChild(imgEl);

    let infoPdp = document.createElement('div');
    infoPdp.className = 'infoPDP';

    infoPdp.innerHTML = doc.getElementById('content-pdp').querySelector('.info-pdp').innerHTML;

    gridEl.appendChild(divElImg);
    gridEl.appendChild(infoPdp);

    content.appendChild(gridEl);

    let actionEl = document.createElement('div');
    actionEl.className = 'action';

    let elBack = document.createElement('div');
    elBack.className = 'btn-back';
    elBack.innerHTML = 'Seleccionar otra';
    elBack.addEventListener('click', function () {
      if (typeProduct == 'simple') {
        self.closePopupMobile();
      } else {
        modelMobile.querySelector('.title').innerHTML = 'Seleccionar producto';
        document.getElementById('model-quick-add-mobile').querySelector('.variant-color').classList.add('active');
        document.getElementById('model-quick-add-mobile').querySelector('.variant-option').classList.remove('active');
      }
    });

    let elAddCart = document.createElement('div');
    elAddCart.className = 'btn-submit-quick-add-cart';
    elAddCart.innerHTML =
      'Añadir al carrito <div class="loading__spinner hidden">' +
      '  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="61px" height="61px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">\n' +
      '    <circle cx="50" cy="50" fill="none" stroke="#000" stroke-width="11" r="35" stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(220.188 50 50)">\n' +
      '      <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>\n' +
      '    </circle>\n' +
      '  </svg></div>';

    elAddCart.addEventListener('click', async function () {
      let selectOption = doc.getElementById('content-pdp').querySelector('#products-select-variants');
      await self.addProductToCartWhenOnlyOption(selectOption);
    });

    actionEl.appendChild(elBack);
    actionEl.appendChild(elAddCart);

    content.appendChild(actionEl);

    modelMobile.querySelector('.variant-option').appendChild(content);
  }

  showError(mess) {
    let elError = document.createElement('div');
    elError.className = 'notification error';
    elError.innerHTML = mess;
    if (
      this.querySelector('.card_product_class') &&
      !this.querySelector('.add-to-cart-button-class').classList.contains('error')
    ) {
      let elCardProductClass = this.querySelector('.card_product_class');
      elCardProductClass.appendChild(elError);
      setTimeout(function () {
        elCardProductClass.querySelector('.notification.error').remove();
      }, 2000);
    }
  }

  clearError() {
    if (this.querySelector('.card_product_class').querySelector('.error')) {
      this.querySelector('.card_product_class').querySelector('.error').remove();
    }
  }

  async quickAddCart() {
    let self = this;
    let isChoose = true;
    let titleValue = '';

    if (
      this.querySelector('.popup-quick-add') &&
      this.querySelector('.popup-quick-add').querySelector('.notification.error')
    ) {
      this.querySelector('.popup-quick-add').querySelector('.notification.error').remove();
    }
    if (
      document.getElementById('model-quick-add-mobile') &&
      document.getElementById('model-quick-add-mobile').querySelector('.notification.error')
    ) {
      document.getElementById('model-quick-add-mobile').querySelector('.notification.error').remove();
    }

    let optionSelect = this.querySelectorAll('.option-varian-select');
    if (optionSelect.length <= 0) {
      optionSelect = document.getElementById('model-quick-add-mobile').querySelectorAll('.option-varian-select');
    }

    optionSelect.forEach((option) => {
      let optionSelected = option.querySelector('input[type="radio"]:checked');
      if (optionSelected) {
        let value = optionSelected.value;
        titleValue += value;
      } else {
        isChoose = false;
      }
    });

    if (!isChoose || titleValue == '') {
      let elError = document.createElement('div');
      elError.className = 'notification error';
      elError.innerHTML = window.productString.errorChooseFull;
      if (window.screen.width > 768) {
        if (this.querySelector('.popup-quick-add')) {
          let elPopupQuickAdd = this.querySelector('.popup-quick-add');
          elPopupQuickAdd.appendChild(elError);
          setTimeout(function () {
            elPopupQuickAdd.querySelector('.notification.error').remove();
          }, 2000);
        }
      } else {
        if (document.getElementById('model-quick-add-mobile')) {
          document.getElementById('model-quick-add-mobile').appendChild(elError);
          setTimeout(function () {
            document.getElementById('model-quick-add-mobile').querySelector('.notification.error').remove();
          }, 2000);
        }
      }
      return;
    }

    titleValue = titleValue.replaceAll(/\s/g, '').replaceAll('/', '').toLocaleLowerCase();
    let typeProduct = this.getAttribute('data-type-product');
    let idVariant = await this.getIdVariantByTitle(titleValue, typeProduct);
    if (idVariant) {
      await self.addToCart(idVariant, this);
    }
  }

  async addToCart(idVariant, self) {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    const formData = new FormData();
    formData.append('id', idVariant);
    if (self.cart) {
      formData.append(
        'sections',
        self.cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      self.cart.setActiveElement(document.activeElement);
    }

    let urlProduct = null,
      productIdSelect;
    if (this.querySelector('.option-varian-1:checked')) {
      urlProduct = this.querySelector('.option-varian-1:checked').getAttribute('data-product-url');
      productIdSelect = this.querySelector('.option-varian-1:checked').getAttribute('data-product-id');
    }
    if (document.getElementById('model-quick-add-mobile').querySelector('.option-varian-1:checked')) {
      urlProduct = document
        .getElementById('model-quick-add-mobile')
        .querySelector('.option-varian-1:checked')
        .getAttribute('data-product-url');
      productIdSelect = document
        .getElementById('model-quick-add-mobile')
        .querySelector('.option-varian-1:checked')
        .getAttribute('data-product-id');
    }

    let elProduct = this,
      variantNotAdd = '';
    let typeProduct = this.getAttribute('data-type-product');
    if (typeProduct == 'bundle') {
      elProduct = document.querySelector(`slider-image-card[data-id="${productIdSelect}"]`);
    }

    let doc = await self.getDataVariationProduct(urlProduct);
    if (elProduct) {
      variantNotAdd = elProduct.querySelector('.list-variant-not-active');
    } else {
      variantNotAdd = doc.getElementById('content-pdp').querySelector('#list-variant-not-active');
    }
    let listVariantPreOrder = doc
      .getElementById('content-pdp')
      .querySelector('.list-variant-preorder')
      .querySelector('.list');
    listVariantPreOrder = listVariantPreOrder.innerHTML;
    let variantIsPreOrder = false;
    if (listVariantPreOrder == '') {
      variantIsPreOrder = true;
    } else {
      listVariantPreOrder = listVariantPreOrder.split(',');
      if (listVariantPreOrder.find((element) => element == idVariant)) {
        variantIsPreOrder = true;
      }
    }
    if (variantIsPreOrder) {
      formData.append('properties[_preorder]', 'true');
    }

    config.body = formData;

    let idVariantAdd = formData.get('id');
    if (variantNotAdd) {
      variantNotAdd = variantNotAdd.textContent;
      if (variantNotAdd.search(idVariantAdd) > -1) {
        let elError = document.createElement('div');
        elError.className = 'notification error';
        elError.innerHTML = window.productString.notAddToCart;
        if (window.screen.width > 768) {
          if (self.querySelector('.card__content')) {
            elError.style.paddingTop = '12px';
            elError.style.paddingLeft = '12px';
            self.querySelector('.card__content').appendChild(elError);
          }
        } else {
          if (document.getElementById('model-quick-add-mobile')) {
            document.getElementById('model-quick-add-mobile').appendChild(elError);
          }
        }
        setTimeout(function () {
          document.querySelectorAll('.notification.error').forEach((item) => {
            item.remove();
          });
        }, 2500);
        return;
      }
    }

    let btnAddToCart =
      this.querySelector('.btn-submit-quick-add-cart') ||
      document.getElementById('model-quick-add-mobile').querySelector('.btn-submit-quick-add-cart');
    if (btnAddToCart) {
      btnAddToCart.disabled = true;
      btnAddToCart.setAttribute('aria-disabled', true);
      btnAddToCart.classList.add('loading');
      btnAddToCart.querySelector('.loading__spinner').classList.remove('hidden');
    }
    await fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          let elError = document.createElement('div');
          elError.className = 'notification error';
          elError.innerHTML = response.description;
          if (window.screen.width > 768) {
            if (self.querySelector('.card__content')) {
              elError.style.paddingTop = '12px';
              elError.style.paddingLeft = '12px';
              self.querySelector('.card__content').appendChild(elError);
            }
          } else {
            if (document.getElementById('model-quick-add-mobile')) {
              document.getElementById('model-quick-add-mobile').appendChild(elError);
            }
          }
          setTimeout(function () {
            document.querySelectorAll('.notification.error').forEach((item) => {
              item.remove();
            });
          }, 2500);
          return;
        }
        self.cart.renderContents(response);
        if (window.screen.width > 768) {
          self.querySelector('.btn-quick-add-cart').setAttribute('data-open', 'false');
        } else {
          self.closePopupMobile();
        }
      })
      .catch(function (err) {})
      .finally(async () => {
        if (this.querySelector('.add-to-cart-button-class')) {
          this.querySelector('.add-to-cart-button-class').classList.remove('notshow');
        }
        if (this.querySelector('.popup-quick-add')) {
          this.querySelector('.popup-quick-add').classList.remove('active');
        }
        if (this.querySelector('.btn-quick-add-cart')) {
          this.querySelector('.btn-quick-add-cart').setAttribute('data-open', 'true');
        }
        if (this.querySelector('.add-to-cart-button-class')) {
          this.querySelector('.add-to-cart-button-class').classList.remove('notshow');
        }
        if (btnAddToCart) {
          btnAddToCart.disabled = false;
          btnAddToCart.setAttribute('aria-disabled', false);
          btnAddToCart.classList.remove('loading');
          btnAddToCart.querySelector('.loading__spinner').classList.add('hidden');
        }
      });
  }

  async getIdVariantByTitle(title, typeProduct) {
    let self = this;
    let productIdSelect = null,
      urlProduct = null;
    if (this.querySelector('.option-varian-1:checked')) {
      productIdSelect = this.querySelector('.option-varian-1:checked').getAttribute('data-product-id');
      urlProduct = this.querySelector('.option-varian-1:checked').getAttribute('data-product-url');
    }
    if (document.getElementById('model-quick-add-mobile').querySelector('.option-varian-1:checked')) {
      productIdSelect = document
        .getElementById('model-quick-add-mobile')
        .querySelector('.option-varian-1:checked')
        .getAttribute('data-product-id');
      urlProduct = document
        .getElementById('model-quick-add-mobile')
        .querySelector('.option-varian-1:checked')
        .getAttribute('data-product-url');
    }
    let elProduct = this;
    if (typeProduct == 'bundle') {
      elProduct = document.querySelector(`slider-image-card[data-id="${productIdSelect}"]`);
    }

    let option = null;
    if (elProduct) {
      option = elProduct.querySelector('.main_product_form_varaiants_class').querySelectorAll('option');
    } else {
      let doc = await self.getDataVariationProduct(urlProduct);
      option = doc.getElementById('content-pdp').querySelector('#products-select-variants');
      option = option.querySelectorAll('option');
    }

    let idVarianOption;
    option.forEach((item) => {
      let valueOption = item.innerHTML.replaceAll(/\s/g, '').replaceAll('/', '').toLocaleLowerCase();
      if (valueOption == title) {
        idVarianOption = item.getAttribute('value');
        return;
      }
    });
    return idVarianOption;
  }
}
customElements.define('slider-image-card', cardProduct);
